import { useState } from 'react';
import { useAsyncFunction, useSafeState } from '../../hooks';
import { selfServiceClient } from '../services/selfService';
import { BillingTableItem } from './types';
import { useUpdateBillingItemQuery } from './useUpdateBillingItemQuery';

export const poNumberMaxLength = 255;

export const useUpdatePONumber = ({
  item,
  onSuccess,
}: {
  item: BillingTableItem;
  onSuccess: (poNumber: string) => void;
}) => {
  const [poNumber, setPONumber] = useState(item.PONumber__c || '');
  const [error, setError] = useSafeState<Error>();
  const updateBillingTableItem = useUpdateBillingItemQuery();
  const [updatePONumber, isLoading] = useAsyncFunction(selfServiceClient.updatePONumber);

  const update = () =>
    void updatePONumber(item, poNumber)
      .then(() => onSuccess(poNumber))
      .then(() => updateBillingTableItem({ ...item, PONumber__c: poNumber }))
      .catch(setError);

  return {
    setPONumber,
    poNumber: poNumber.slice(0, poNumberMaxLength),
    isLoading,
    update,
    error: error instanceof Error ? error.message : undefined,
  };
};
